module.exports = __webpack_public_path__ + "eventbrite_app_product_page_design_template.zip";